// Template 기반 Include 시스템
class TemplateInclude {
    constructor() {
        this.templates = new Map();
        this.init();
    }

    async init() {
        // 모든 템플릿 미리 로드
        await this.preloadTemplates();
        this.processIncludes();
    }

    async preloadTemplates() {
        const templateUrls = [
            'includes/header.html',
            'includes/footer.html',
            'includes/header-auth.html',
            'includes/footer-auth.html'
        ];

        const promises = templateUrls.map(async (url) => {
            try {
                const response = await fetch(url);
                if (response.ok) {
                    const html = await response.text();
                    const templateName = url.split('/').pop().replace('.html', '');
                    this.templates.set(templateName, html);
                }
            } catch (error) {
            }
        });

        await Promise.all(promises);
    }

    processIncludes() {
        document.querySelectorAll('[data-template]').forEach(element => {
            const templateName = element.getAttribute('data-template');
            const html = this.templates.get(templateName);
            
            if (html) {
                element.innerHTML = html;
                element.removeAttribute('data-template');
            }
        });
    }
}

// 사용법
// <div data-template="header"></div>
// <div data-template="footer"></div>

// 초기화
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new TemplateInclude());
} else {
    new TemplateInclude();
}